<template>
	<div class="rows">
		<ValidationProvider
			ref="provider"
			:name="options.label"
			:vid="name"
			:rules="computedRules"
			v-slot="{ errors, classes }"
			slim
		>
			<div :class="[options.wrapperClass, 'relative']">
				<label class="input-label d-table w-100 text-center" v-if="options.sidebar">{{ options.label }}</label>
				<span
					:class="[
						options.tooltip ? 'input-tooltip' : '',
						options.unit ? 'input-unit' : '',
						'w-100',
						options.className,
						classes,
					]"
				>
					<input
						:placeholder="options.label"
						type="text"
						:class="options.className"
						:id="generatedId"
						:value="getData()"
						@input="handleInput"
						v-mask="options.mask"
						@keyup="handleKeyUp"
						@focus="handleFocus"
						@blur="handleBlur"
						:inputmode="options.inputmode"
						autocomplete="disabled"
						data-hj-allow
					/>
					<span v-if="options.unit" class="unit">{{ options.unit }}</span>
					<span v-if="options.tooltip" v-tooltip="options.tooltipText" class="info"></span>
				</span>
				<span :class="['error_message error_message--broke', options.className]">{{ errors[0] }}</span>
				<ul class="searchResult" v-show="showResults" :style="computedStyleForSearchAddress">
					<li
						v-for="(result, index) in getSearchResultByGroup(name, options.refGroup)"
						:key="index"
						@mousedown="handleClick($event, result)"
					>
						<span v-if="name === 'postal_code' || name === 'city'">
							{{ result.postal_code.substring(0, 4) }} - {{ result.name }}
						</span>
						<span v-else>
							{{ result.postal_code.substring(0, 4) }} {{ result.city.name }}, {{ result.name }}
							{{ result.nature }}
						</span>
					</li>
				</ul>
			</div>
		</ValidationProvider>
	</div>
</template>

<script>
import shared from '@/mixins/shared';
import { mapGetters } from 'vuex';
import _ from 'lodash';

export default {
	mixins: [shared],
	props: {},
	async mounted() {
		if (this.getData() !== null) {
			await this.loadAddress(this.name, this.getData());
		}
	},
	data() {
		return {
			results: false,
			rules: this.options.rules,
		};
	},
	computed: {
		...mapGetters(['getSearchResultByGroup', 'getSearchResult']),
		showResults() {
			if (this.getSearchResultByGroup(this.name, this.options.refGroup) !== undefined) {
				return this.getSearchResultByGroup(this.name, this.options.refGroup).length > 0 && this.results;
			}

			return false;
		},
		computedStyleForSearchAddress() {
			return this.name === 'address' && !this.isMobile ? 'left: 30px;' : '';
		},
		computedRules() {
			return this.name === 'city' || this.name === 'address' || this.name === 'address_name'
				? {
						...this.options.rules,
						search: {
							results: this.getSearchResultByGroup(this.name, this.options.refGroup),
							prop: this.name,
						},
				  }
				: this.options.rules;
		},
	},
	methods: {
		async setPostalCodeAndCity(e, postal_code, city) {
			e.preventDefault();
			e.stopPropagation();

			this.handleSetData('postal_code', postal_code);
			this.handleSetData('city', city);

			this.results = false;

			await this.loadAddress('city', city);

			if (this.type === 'calculation') {
				this.validateOthers({
					city: city,
					postal_code: postal_code,
				});
			}

			if (this.type === 'contracting') {
				this.validateOthers({
					[`${this.options.refGroup}-city`]: city,
					[`${this.options.refGroup}-postal_code`]: postal_code,
				});
			}
		},
		async setAddress(e, postal_code, city, addressName, addressType = null) {
			e.preventDefault();
			e.stopPropagation();

			this.handleSetData('postal_code', postal_code);
			this.handleSetData('city', city);
			let address = addressType !== null ? `${addressName} ${addressType}` : addressName;

			if (this.type === 'calculation') {
				this.handleSetData('address', address);
			}

			if (this.type === 'contracting') {
				this.handleSetData('address_name', addressName);
				this.handleSetData('address_type', addressType);
			}

			this.results = false;

			await this.loadAddress('city', city);

			if (this.type === 'calculation') {
				this.validateOthers({
					city: city,
					postal_code: postal_code,
					address: address,
				});
			}

			if (this.type === 'contracting') {
				this.validateOthers({
					[`${this.options.refGroup}-city`]: city,
					[`${this.options.refGroup}-postal_code`]: postal_code,
					[`${this.options.refGroup}-address_name`]: addressName,
					[`${this.options.refGroup}-address_type`]: addressType,
				});
			}
		},
		async handleKeyUp(e) {
			await this.loadAddress(this.name, e.target.value);
			this.results = true;
		},
		async handleFocus() {
			if (this.getData() !== null) {
				await this.loadAddress(this.name, this.getData());
				this.results = true;
			}

			if (this.getSearchResultByGroup(this.name, this.options.refGroup) !== undefined) {
				if (this.getSearchResultByGroup(this.name, this.options.refGroup).length > 0) {
					this.results = true;
				}
			}
		},
		async handleBlur(e) {
			e.preventDefault();
			e.stopPropagation();

			if (this.getSearchResultByGroup(this.name, this.options.refGroup) !== undefined) {
				if (this.getSearchResultByGroup(this.name, this.options.refGroup).length === 1) {
					if (this.name === 'postal_code' && this.getData().toString().length === 4) {
						await this.setPostalCodeAndCity(
							e,
							this.getSearchResultByGroup(this.name, this.options.refGroup)[0].postal_code,
							this.getSearchResultByGroup(this.name, this.options.refGroup)[0].name,
						);
					}

					if (this.name === 'city') {
						await this.setPostalCodeAndCity(
							e,
							this.getSearchResultByGroup(this.name, this.options.refGroup)[0].postal_code,
							this.getSearchResultByGroup(this.name, this.options.refGroup)[0].name,
						);
					}

					if (this.name === 'address' || this.name === 'address_name') {
						await this.setAddress(
							e,
							this.getSearchResultByGroup(this.name, this.options.refGroup)[0].postal_code,
							this.getSearchResultByGroup(this.name, this.options.refGroup)[0].city.name,
							this.getSearchResultByGroup(this.name, this.options.refGroup)[0].name,
							this.getSearchResultByGroup(this.name, this.options.refGroup)[0].nature,
						);
					}
				}
			}

			this.results = false;
		},
		handleInput(e) {
			this.setData(this.computedValue(e.target.value));
		},
		async handleClick(e, result) {
			if (this.name === 'postal_code' || this.name === 'city') {
				await this.setPostalCodeAndCity(e, result.postal_code, result.name);
				await this.setAddress(e, result.postal_code, result.name);
			} else {
				await this.setAddress(e, result.city.postal_code, result.city.name, result.name, result.nature);
			}
		},
		handleSetData(prop, value) {
			if (this.type === 'calculation') {
				this.setInputData({
					group: 'real_estate',
					key: prop,
					value: this.computedValue(value),
					index: this.index,
				});
			}

			if (this.type === 'contracting') {
				this.setFormData({
					parent: this.options.input.parent,
					group: this.options.input.group,
					prop: prop,
					value: this.computedValue(value),
					index: this.options.index === undefined ? this.index : this.options.index ?? null,
				});
			}
		},
		validateOthers(others) {
			_.each(others, (value, ref) => {
				if (value !== null && value !== undefined) {
					this.$parent.$parent.$refs[ref][0].$children[0].$refs.provider.validate(value);
				}
			});
		},
		async loadAddress(type, value) {
			await this.$store.dispatch(this.options.apiSearch, {
				type: type,
				value: this.computedValue(value),
				postal_code: this.getData('postal_code'),
				group: this.options.refGroup,
			});
		},
	},
};
</script>

<style lang="scss" scoped>
.searchResult {
	position: absolute;
	max-height: 200px;
	overflow-y: scroll;
	z-index: 99;
	background: white;
	margin-top: 0;
	list-style-type: none;
	padding: 5px;
	top: 48px;
	border: 1px #ccc solid;
	border-radius: 10px;

	li {
		padding: 5px 10px;
		transition: 0.3s;
		cursor: pointer;

		&:hover {
			background-color: #ccc;
		}
	}
}

.relative {
	position: relative;
}
</style>
